@if( getActiveTab() == TAB_CAMPAIGN ) {
    <streaming-campaign-grid-component #tabCampaign></streaming-campaign-grid-component>
}
@if( getActiveTab() == TAB_PENDINGREJECTED ) {
    <streaming-creativity-grid-component #tabPending [filter]="pendingRejectedFilter" [refreshOnInit]="true"></streaming-creativity-grid-component>
}
@if( getActiveTab() == TAB_HISTORY ) {
    <streaming-creativity-grid-component #tabHistory [allowFiltering]="true" [filter]="latestFilter" [refreshOnInit]="true"></streaming-creativity-grid-component>
}

  <button class="fab fab-left" (click)="onNewCampaign()">
    <i class="fa-solid fa-plus"></i>
    New Campaign
  </button>
